import { connect } from 'react-redux';
import { compose, withStateHandlers } from 'recompose';
import moment from 'moment';

import { agreementsByIds } from '../../../entities/Agreement/selectors';
import { Endpoints } from '../../../lib/LeanLinkService';
import withPagination from '../../PaginatedItems/withPagination';
import debounceProp from '../../../lib/debounceProp';
import RichSelect from '../RichSelect/RichSelect';
import { withTranslation } from 'react-i18next';

const entityToValue = agreement => ({
  value: agreement.id,
  label: agreement.name,
});

const withAgreements = connect((state, { ids }) => (
  {
    options: agreementsByIds(state, ids).map(entityToValue),
  }
));

export default compose(
  withTranslation(),
  withStateHandlers(
    props =>
    ({
      placeholder: props.t('Välj avtal'),
      url: Endpoints.agreements.list({
        customers: props.customerId,
        includeHierarchyAgreements: true,
        staffingCompany: props.staffingCompanyId,
        expiresAfter: moment().format('YYYY-MM-DD'),
        resources: props.resources,
        exact: false,
        type: props.type,
        ...(props.maxItems && { limit: props.maxItems }),
        name: '',
      }),
    }),
    {
      onChangeText:
        (state, props) =>
          name =>
          ({
            ...state,
            url: Endpoints.agreements.list({
              customers: props.customerId,
              includeHierarchyAgreements: true,
              staffingCompany: props.staffingCompanyId,
              expiresAfter: moment().format('YYYY-MM-DD'),
              resources: props.resources,
              exact: false,
              type: props.type,
              ...(props.maxItems && { limit: props.maxItems }),
              name,
            }),
          }),
    },
  ),
  debounceProp('url'),
  withPagination(),
  withAgreements,
)(RichSelect);
